"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createShuffledArray = exports.shuffle = void 0;
/**
 * Shuffle array using Durstenfeld shuffle: https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle#The_modern_algorithm
 * Modifies array in place.
 * https://stackoverflow.com/a/12646864
 * @param array Array to shuffle
 * @returns Shuffled referenced array
 */
function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}
exports.shuffle = shuffle;
/**
 * Shuffle array using Durstenfeld shuffle: https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle#The_modern_algorithm
 * https://stackoverflow.com/a/12646864
 * @param array Array to shuffle
 * @returns Shuffled copy of passed in array
 */
const createShuffledArray = array => shuffle([...array]);
exports.createShuffledArray = createShuffledArray;
//# sourceMappingURL=shuffleArray.js.map